import {formatNumber, stringToNumber} from "./common";

/**
 * @param {Object} type - buy / sell
 * @param {string} tradeType - p2p / otc
 * @param {Object} wages - wages
 * @param data - main data - p2pData / otcData
 * @param socketContent - socket - buy and sell orders uses here
 * @param market - coin / pair
 */
const getCalculatedWages = (type, tradeType, wages, data, socketContent, market  ) => {

    let operationType;
    let affPair = 0;
    let affValue = 0

    if (tradeType === "p2p") {
        if (type === "buy") {
            operationType = stringToNumber(data.price) < Math.min(...socketContent?.sellOrders?.map(o => o.priceUnit)) ? "maker" : "taker"
        }else {
            operationType = stringToNumber(data.price) > Math.max(...socketContent?.buyOrders?.map(o => o.priceUnit)) ? "maker" : "taker"
        }
    }else {
        operationType = "maker" // TODO : Should change to taker in api and code
    }
    const totalPair = stringToNumber(data.price) * stringToNumber(data.amount)
    let feePair = wages.wage[operationType].factor * totalPair / 100
    let feeValue = wages.wage[operationType].factor * stringToNumber(data.amount) / 100

    const wageMax = wages.wage[operationType].max
    if (wageMax && wageMax < feeValue) {
        feeValue = wageMax
        feePair = wageMax * stringToNumber(data.price)
    }

    const feeOffPair = wages.stars?.off * feePair / 100
    const feeOffValue = wages.stars?.off * feeValue / 100
    if (wages.affiliate?.calculated) {
        if (type === 'buy') {
            affPair = wages.affiliate.calculated * stringToNumber(data.price)
            affValue = wages.affiliate.calculated
        }else {
            affPair = wages.affiliate.calculated
            affValue = wages.affiliate.calculated / stringToNumber(data.price)
        }

    }
    const receiveValue = stringToNumber(data.amount) - feeValue + feeOffValue + affValue
    const receivePair = totalPair - feePair + feeOffPair + affPair

    return {
        totalPair: formatNumber(totalPair, { type: market.pair }),
        totalValue: data.amount,
        feePair: formatNumber(feePair, {type: market.pair}),
        feeValue: formatNumber(feeValue),
        feeOffPair: formatNumber(feeOffPair, { type: market.pair }),
        feeOffValue: formatNumber(feeOffValue),
        affPair: formatNumber(affPair, { type: market.pair }),
        affValue: formatNumber(affValue),
        receivePair: formatNumber(receivePair, { type: market.pair }),
        receiveValue: formatNumber(receiveValue),
        withdrawPair: 0,
        withdrawValue: 0,
        loading: false
    }
}


const getExtraWages = (
    networks,
    data,
    type
) => {

    const wages = []
    const nets = networks[type === "buy" ? "withdraw" : "deposit"]
    nets?.forEach(net => {
        const total = parseFloat(stringToNumber(data.total))
        const price = parseFloat(stringToNumber(data.price))

        let fee = total * net.feeFactor / 100
        let feeValue = fee / price

        if (net.feeMax && feeValue > net.feeMax) {
            feeValue = net.feeMax
            fee = feeValue * price
        }

        let payload = {
            network: net.network,
            fee, feeValue
        }

        // TODO: we should consider normal fees too
        const receive = total - fee
        if (receive > net.max && type === "sell") {
            payload = {
                ...payload,
                showNote: true,
                receiveMax: net.max
            }
        }

        wages.push(payload)
    })

    return wages
}


// const orders =
//     [
//         {"_id":"63661d7001247668752d3f4b","type":"sell","amount":4,"price":1999600000,"priceUnit":499900000},
//         {"_id":"63661d4601247668752d3f49","type":"sell","amount":6,"price":2999994000,"priceUnit":499999000},
//         {"_id":"63660812be3f8961f96f76a8","type":"sell","amount":7.529766,"price":3764883000,"priceUnit":500000000},
//         {"_id":"635cdd2ea0488557617317f4","type":"sell","amount":0.054535,"price":30514639,"priceUnit":559542289},
//         {"_id":"6359173f29ab5b40fc606695","type":"sell","amount":0.0009,"price":504472,"priceUnit":560524539},
//         {"_id":"6359173f29ab5b40fc606699","type":"sell","amount":0.0004,"price":224209,"priceUnit":560524539},
//         {"_id":"6359173f29ab5b40fc606697","type":"sell","amount":0.0007,"price":392367,"priceUnit":560524539},
//         {"_id":"6359173f29ab5b40fc606693","type":"sell","amount":0.00006,"price":33632,"priceUnit":560524539},
//         {"_id":"63590ee929ab5b40fc6060ec","type":"sell","amount":0.001,"price":566010,"priceUnit":566010635},
//         {"_id":"63590ee929ab5b40fc6060ea","type":"sell","amount":0.0003,"price":169803,"priceUnit":566010635},
//         {"_id":"63590ee929ab5b40fc6060e6","type":"sell","amount":0.0003,"price":169803,"priceUnit":566010635},
//         {"_id":"63590ee929ab5b40fc6060ee","type":"sell","amount":0.0004,"price":226404,"priceUnit":566010635},
//         {"_id":"63590ee929ab5b40fc6060f0","type":"sell","amount":0.0009,"price":509409,"priceUnit":566010635},
//         {"_id":"63590ee929ab5b40fc6060e8","type":"sell","amount":0.0009,"price":509409,"priceUnit":566010635},
//         {"_id":"63590ee929ab5b40fc6060f2","type":"sell","amount":0.0004,"price":226404,"priceUnit":566010635},
//         {"_id":"63590ee829ab5b40fc6060e2","type":"sell","amount":0.0006,"price":339606,"priceUnit":566010635},
//         {"_id":"63590ee929ab5b40fc6060f4","type":"sell","amount":0.0005,"price":283005,"priceUnit":566010635},
//         {"_id":"63590ee829ab5b40fc6060e4","type":"sell","amount":0.0004,"price":226404,"priceUnit":566010635},
//         {"_id":"63590ee829ab5b40fc6060e0","type":"sell","amount":0.0008,"price":452808,"priceUnit":566010635},
//         {"_id":"63590ee829ab5b40fc6060da","type":"sell","amount":0.0008,"price":452808,"priceUnit":566010635}
//     ]


export {
    getCalculatedWages,
    getExtraWages
}
